/**
 * Fragno boot for the VEX-7983 header (`fragnoLogoEnabled`).
 *
 * The rebrand ships as `fragno-next` (`npm:fragno@next`). Only its web
 * components and styles are loaded, not the React wrappers: screens render the
 * `<fragno-*>` tags directly, and the browser upgrades them once the JS has
 * defined them.
 *
 * Nothing imports Fragno up front. ConsumerProvider calls `loadFragno()` when
 * IDME_INIT arrives with the flag on; integrations without the flag never
 * download any Fragno file, so their pages are unchanged from before VEX-7983.
 */

import { logger } from "../utils/logger";

let loaded: Promise<void> | null = null;

/** Loads Fragno's tokens, styles and web components once per page. */
export function loadFragno(): Promise<void> {
  if (loaded) return loaded;
  const done = (async () => {
    // Tokens must apply before fragno.css.
    await import("fragno-next/dist/tokens-light.css");
    await import("fragno-next/dist/fragno.css");
    await import("fragno-next");
  })();
  loaded = done;
  done.catch((error) => {
    logger.error("[Fragno] failed to load:", error);
    // A failed import may be retried by the next caller.
    if (loaded === done) loaded = null;
  });
  return done;
}

/** Whether Fragno has been requested for this page. */
export function isFragnoLoading(): boolean {
  return loaded !== null;
}

/** Tests only: forget the loaded package. */
export function resetFragnoForTests(): void {
  loaded = null;
}
